import React, { useEffect, useState } from 'react';
import useStyles from './useStyles';
import { withScoutTheme } from '../../../ThemeContext/ThemeContext';
import PropTypes from 'prop-types';
import axios from 'axios';
import ReactLoading from 'react-loading';
import queryString from 'query-string'

import CandidateListItem from './components/CandidateListItem';
import ChatWindow from './components/ChatWindow';
import ChatBox from './components/ChatBox';
import CandidateFilter from './components/CandidateFilter';
import CandidateDetails from './components/CandidateDetails';
import moment from 'moment';

function Messenger({ job, setLargeModal, statuses, selectedApplications, setSelectedApplications, isGroupMessage, config, applications }) {
  const [conversationsLoading, setConversationsLoading] = useState(true);
  const [userOptionsLoading, setUserOptionsLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [conversations, setConversations] = useState([]);
  const [userOptions, setUserOptions] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [showSidebar, setShowSidebar] = useState(true);
  const [selectedConversation, setSelectedConversation] = useState([])
  const [body, setBody] = useState('');
  const [signature, setSignature] = useState('');
  const [scheduleDate, setScheduleDate] = useState(null);
  const [scheduleTime, setScheduleTime] = useState(moment().add('1 h').format('hh:mm'));
  const [isPm, setIsPm] = useState(false);
  const [groupMessage, setGroupMessage] = useState(isGroupMessage);

  const classes = useStyles();

  useEffect(() => {
    async function initData() {
      const conversations = await fetchConversations(selectedApplications);
      setConversations(conversations)
      fetchUserOptions()
    }
    initData()
  }, [selectedApplications])

  useEffect(() => {
    if (conversations.length === 1 || selectedConversation.length > 1) {
      setLargeModal(false)
      setShowSidebar(false)
    } else {
      setLargeModal(true)
      setShowSidebar(true)
    }
  }, [conversations, selectedConversation])

  useEffect(() => {
    setBody('')
    setSignature('')
  }, [selectedConversation])

  async function fetchUserOptions() {
    setUserOptionsLoading(true)
    try {
      const { data } = await axios.get('/admin/integrations/textus/user_options')
      setUserOptions(data)
    } catch(e) {
      console.log(e)
    } finally {
      setUserOptionsLoading(false)
    }
  }

  async function fetchConversations(applications) {
    setConversationsLoading(true);
    try {
      const { data: conversationsData } = await axios.get('/admin/integrations/textus/conversations', {
        ...config,
        params: {
          job_id: job.id,
          ...(applications.length === 1 && { candidate_id: applications[0].candidate_id })
        },
        paramsSerializer: params => queryString.stringify(params, { arrayFormat: 'bracket' }),
      })
      const conversations = applications.map(app => {
        const matchingConversation = conversationsData && conversationsData.find(convo => convo && convo.candidate_id === app.candidate_id)
        return {
          id: app.id,
          candidate_id: app.candidate_id,
          candidate_name: app.name,
          candidate_phone: app.phone,
          candidate_status: app.status,
          candidate_tags: app.tags,
          messages: matchingConversation ? matchingConversation.messages : []
        }
      })
      groupMessage
        ? setSelectedConversation(conversations)
        : setSelectedConversation([conversations[0]])
      return conversations
    } catch(e) {
      console.log(e)
    } finally {
      setConversationsLoading(false)
    }
  }

  function handleTimeValueForPost(value) {
    const time = value.replace(/-/g, ':');
    const [hour, minute] = time.split(':')
    if (isPm) {
      return parseInt(hour) === 12
        ? `00:${minute}:00`
        : `${parseInt(hour) + 12}:${minute}:00`
    } else {
      return `${hour}:${minute}:00`
    }
  }

  async function handleSend() {
    setSending(true)
    try {
      if (groupMessage) {
        const { data } = await axios.post('/admin/integrations/textus/campaigns', {
          job_id: job.id,
          candidate_ids: selectedApplications.map(app => app.candidate_id),
          campaign_title: `${job.reference} - ${job.title} (${moment().format('LLLL')})`,
          body: body,
          schedule_time: scheduleDate ? moment(`${scheduleDate} ${handleTimeValueForPost(scheduleTime)}`).format() : null
        }, config)
        const newConversations = conversations.map(convo => ({
          ...convo,
          messages: [data.messages[0], ...convo.messages].filter(msg => msg)
        }))
        const existingConversations = await fetchConversations(applications.filter(app => !selectedApplications.map(selected => selected.candidate_id).includes(app.candidate_id)));
        const combinedConversations = [...newConversations, ...existingConversations];
        setGroupMessage(false)
        setConversations(combinedConversations)
        setSelectedConversation([combinedConversations[0]])
      } else {
        const { data } = await axios.post('/admin/integrations/textus/messages', {
          job_id: job.id,
          candidate_id: selectedConversation[0].candidate_id,
          body: body,
          signature: signature,
          schedule_time: scheduleDate ? moment(`${scheduleDate} ${handleTimeValueForPost(scheduleTime)}`).format() : null
        }, config)
        const newConversation = {
          ...selectedConversation[0],
          messages: [data.messages[0], ...selectedConversation[0].messages]
        }
        setSelectedConversation([newConversation])
        setConversations([newConversation, ...conversations.filter(convo => convo.candidate_id !== selectedConversation[0].candidate_id)])
      }
    } catch(e) {
      console.log(e)
    } finally {
      setSending(false)
    }
  }

  if (userOptionsLoading || conversationsLoading) return <ReactLoading type='spin' color={'#004E70'} width={45} className={classes.loading} />

  return (
    <div className={classes.root}>
      { showSidebar &&
        <div className={classes.modalLeft}>
          <CandidateFilter
            statuses={statuses}
            selectedStatuses={selectedStatuses}
            setSelectedStatuses={setSelectedStatuses}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            conversations={conversations}
          />
          <div className={classes.candidateList}>
            {conversations
              .filter(convo => selectedStatuses.length > 0 ? selectedStatuses.map(status => status.id).includes(convo.candidate_status) : true && convo.candidate_name.toLowerCase().includes(searchTerm.toLowerCase()))
              .sort((a, b) => !a.messages[0] - !b.messages[0] || a.messages[0] && b.messages[0] && new Date(b.messages[0].sent_time) - new Date(a.messages[0].sent_time))
              .map(convo =>
              <CandidateListItem
                key={convo.id}
                conversation={convo}
                statuses={statuses}
                selectedConversation={selectedConversation}
                setSelectedConversation={setSelectedConversation}
              />
            )}
          </div>
        </div>
      }
      <div className={classes.modalRight} style={{ flexBasis: showSidebar ? '64%' : '100%' }}>
        <CandidateDetails
          conversation={selectedConversation}
        />
        <ChatWindow
          body={body}
          conversation={selectedConversation}
          signature={signature}
        />
        <ChatBox
          body={body}
          setBody={setBody}
          signature={signature}
          setSignature={setSignature}
          conversation={selectedConversation}
          userOptions={userOptions}
          handleSend={handleSend}
          sending={sending}
          scheduleDate={scheduleDate}
          setScheduleDate={setScheduleDate}
          scheduleTime={scheduleTime}
          setScheduleTime={setScheduleTime}
          isPm={isPm}
          setIsPm={setIsPm}
          job={job}
        />
      </div>
    </div>
  )
}

Messenger.propTypes = {
  job: PropTypes.object.isRequired,
  setLargeModal: PropTypes.func.isRequired,
  statuses: PropTypes.array.isRequired,
  selectedApplications: PropTypes.array.isRequired,
  setSelectedApplications: PropTypes.func.isRequired,
  applications: PropTypes.array.isRequired,
  config: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  setSnack: PropTypes.func.isRequired,
}

export default withScoutTheme(Messenger)
